import { AppState } from 'types';
import { StoreType } from '@tock/shared/utils/connect';
import { getBusinessHeader } from '@tock/shared/utils/AjaxActions';
import _ from 'lodash';

export const getActiveAuthSelector = (store: StoreType) => store.app.activeAuth;

export const getJwtTokenSelector = (store: StoreType) => store.app.jwtToken;

export const appPatronSelector = (store: StoreType) => store.app.patron;

export const businessHeaderSelector = (store: StoreType) => getFilteredBusinessHeaders(store.app);

export function getFilteredBusinessHeaders(app: AppState) {
  return _.omitBy(getBusinessHeader(app), _.isUndefined);
}

export const getApolloClientConnectionStateSelector = (store: StoreType) =>
  store.app.apolloClientConnectionState;
